import Reveal from "./Reveal";
import { Container, Eyebrow } from "./Primitives";

const SEQUENCE = [
  "Clarify your business needs",
  "Diagnose the challenge and identify where AI adds value",
  "Build a tailored solution with our AI experts",
  "Deploy, verify quality, and ensure it works",
];

export default function Trust() {
  return (
    <section className="fa-sheet relative z-10 -mt-10 bg-panel py-28 text-fg sm:py-36">
      <Container>
        <div className="grid gap-14 lg:grid-cols-[1fr_1.2fr] lg:gap-24">
          <Reveal>
            <Eyebrow className="text-tone">How we deliver</Eyebrow>
            <h2 className="mt-6 font-display text-4xl font-light leading-[1.02] tracking-[-0.04em] sm:text-5xl">
              AI-powered.<br />Expert-built.
            </h2>
          </Reveal>
          <Reveal delay={120} className="space-y-6 text-base leading-relaxed text-subtle md:text-lg">
            <p>
              Intelligent diagnosis helps pinpoint where your organization is losing time, money or opportunity.
              Then internal AI experts and trusted AI partners design and implement the solution.
            </p>
            <p>
              You work with FreelancAI, not a marketplace. Every engagement goes through managed quality review
              before it reaches your team.
            </p>
          </Reveal>
        </div>
        <Reveal as="ol" delay={180} className="fa-track relative mt-24 grid gap-10 sm:grid-cols-4 sm:gap-4">
          <span aria-hidden className="fa-track-line" />
          <span aria-hidden className="fa-track-pulse" />
          {SEQUENCE.map((s, i) => (
            <li key={s} className="relative pl-8 sm:pl-0 sm:pt-10">
              <span aria-hidden className={`fa-track-dot ${i === SEQUENCE.length - 1 ? "fa-track-dot--end" : ""}`} />
              <span className="font-mono text-[11px] tracking-[0.2em] text-tone">0{i + 1}</span>
              <p className="mt-2 text-[15px] font-medium">{s}</p>
            </li>
          ))}
        </Reveal>
      </Container>
    </section>
  );
}
